import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { LightbulbIcon, SettingsIcon, CpuIcon, BarChart3Icon, MegaphoneIcon, ServerIcon, ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../LanguageContext';
const getServices = (t: any) => [{
  title: t('service_1_title'),
  description: t('service_1_desc'),
  icon: LightbulbIcon
}, {
  title: t('service_2_title'),
  description: t('service_2_desc'),
  icon: SettingsIcon
}, {
  title: t('service_3_title'),
  description: t('service_3_desc'),
  icon: CpuIcon
}, {
  title: t('service_4_title'),
  description: t('service_4_desc'),
  icon: BarChart3Icon
}, {
  title: t('service_5_title'),
  description: t('service_5_desc'),
  icon: MegaphoneIcon
}, {
  title: t('service_6_title'),
  description: t('service_6_desc'),
  icon: ServerIcon
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function Services() {
  const {
    t
  } = useLanguage();
  const services = getServices(t);
  return <section id="services" className="py-24 bg-white relative" data-id="element-287">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-288">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-289">
          <motion.h2 className="text-4xl font-extrabold text-navy mb-4" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} data-id="element-290">
            {t('services_title')}
          </motion.h2>
          <motion.p className="text-lg text-slate-600" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          delay: 0.1
        }} data-id="element-291">
            {t('services_desc')}
          </motion.p>
        </div>

        <motion.div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} data-id="element-292">
          {services.map((service, index) => <motion.div key={index} variants={itemVariants} className="group relative bg-white border border-slate-200 rounded-xl p-8 transition-all duration-300 hover:shadow-2xl hover:shadow-electric/10 hover:-translate-y-2 hover:border-electric/50 overflow-hidden" data-id="element-293">
              {/* Hover Glow Effect */}
              <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-electric/10 rounded-full blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-294" />

              <div className="w-14 h-14 rounded-lg bg-navy/5 flex items-center justify-center mb-6 group-hover:bg-electric group-hover:text-white transition-colors duration-300" data-id="element-295">
                <service.icon className="w-7 h-7 text-electric group-hover:text-white transition-colors duration-300" data-id="element-296" />
              </div>

              <h3 className="text-xl font-bold text-navy mb-3 group-hover:text-electric transition-colors duration-300" data-id="element-297">
                {service.title}
              </h3>

              <p className="text-slate-600 mb-6 leading-relaxed" data-id="element-298">
                {service.description}
              </p>

              <a href="#contact" className="inline-flex items-center text-sm font-semibold text-navy group-hover:text-electric transition-colors duration-300" data-id="element-299">
                {t('learn_more')}
                <ArrowRightIcon className="w-4 h-4 ml-1 transform group-hover:translate-x-1 transition-transform duration-300" data-id="element-300" />
              </a>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}